var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-twitter",
    transform: "translate(-1122 -158)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_white",
    "data-name": "Ellipse white",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1122 158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_grey",
    "data-name": "Ellipse grey",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1125 161)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_013-twitter",
    "data-name": "013-twitter",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5.479,9.356q.008.177.008.356A7.783,7.783,0,0,1,9.65,17.549h0a7.8,7.8,0,0,1-4.222-1.237,5.6,5.6,0,0,0,.657.038,5.527,5.527,0,0,0,3.421-1.179,2.757,2.757,0,0,1-2.573-1.913,2.745,2.745,0,0,0,1.244-.047,2.755,2.755,0,0,1-2.21-2.7c0-.012,0-.024,0-.035a2.735,2.735,0,0,0,1.247.344,2.757,2.757,0,0,1-.853-3.677,7.82,7.82,0,0,0,5.677,2.878,2.756,2.756,0,0,1,4.694-2.512,5.524,5.524,0,0,0,1.749-.669,2.765,2.765,0,0,1-1.211,1.523,5.493,5.493,0,0,0,1.582-.434A5.6,5.6,0,0,1,17.479,9.356Zm0,0",
    transform: "translate(1125 161)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.13e27115f31e9aac15920d74eeaf5a6f.svg";
export { ForwardRef as ReactComponent };